export const storeLocation = (state) => state.checkmateAuthorizationReducer.storeLocation;
export const activateLocationRes = (state) => state.checkmateAuthorizationReducer.activateLocation;
export const locationActivationComplete = (state) => state.checkmateAuthorizationReducer.locationActivationComplete;
export const toggleLeftPanelSelector = (state) => state.checkmateAuthorizationReducer.toggleLeftPanel;
